import React, { Component } from 'react';
import { Helmet } from 'react-helmet'
import { connect } from 'react-redux'
import { Link, withRouter } from 'react-router-dom'
import {getReturnOrderList, getReturnOrderFilterList, getReturnOrderProduct } from "../../actions/returnOrder"
import MobileView from '../common/mobileView'
import FullPageLoader from '../../components/common/fullPageLoader'
import { toast } from 'react-toastify';

class ReturnOrders extends Component {
    constructor(props) {
        super(props);
        this.state={
            returnOrderFilterList:[],
            returnCheckbox:[],
            returnSelect:[],
            returnOrderProduct : [],
        } 
      }

    componentDidMount() {
        const { connection_id, userDetails } = this.props
        this.props.getReturnOrderList(connection_id, userDetails.COM_CONSUMER_MOBILE_NO)
       
    }

    // Select Reason

    handleSelectReason = (event, value, index) => {
        const returnReasonValue = event.target.value;
        if(returnReasonValue !== ''){
            // Validation
            let returnSelectValue =  this.state.returnSelect.filter(function(val) {return val === index})
            if( returnSelectValue.length === 0 ){
                this.setState({ returnSelect : this.state.returnSelect.concat([index]) })
            }
            // End Validation

            // Select Product

            let newReason = {order_no: value.RIH_PRINCIPAL_ORDER_NO,order_associate_code: value.RIH_PRINCIPAL_ORDER_ASSOC_CD,invoice_no: value.rih_invno,invoice_assoc_code: value.rih_assoc_cd,invoice_date: value.rih_inv_dt,lot_code: value.RID_LOT_CD,sl_no: value.RID_SLNO,sku_code: value.RID_SKU_CD,return_qty: value.RID_RETURN_QTY,return_reason:returnReasonValue}
            const countSelectedReason =  this.state.returnOrderFilterList.filter(function(val) {return val.lot_code === value.RID_LOT_CD})
            if(countSelectedReason.length === 0){
               this.setState({ 
                   returnOrderFilterList: this.state.returnOrderFilterList.concat([newReason]),
                   returnOrderProduct : this.state.returnOrderProduct.concat([value])
                })
            }
            else{
               const oldSelectedValue =  this.state.returnOrderFilterList.filter(function(val) {return val.lot_code !== value.RID_LOT_CD})
               const oldSelectedProduct =  this.state.returnOrderProduct.filter(function(val) {return val.RID_LOT_CD !== value.RID_LOT_CD})
               this.setState({ 
                    returnOrderFilterList: oldSelectedValue.concat([newReason]),
                    returnOrderProduct: oldSelectedProduct.concat([value])
             })
            }
        }
        else{
            // Validation
            let returnSelectValue =  this.state.returnSelect.filter(function(val) {return val !== index})
                this.setState({ returnSelect : returnSelectValue })
             
            // Select Product
            const oldSelectedValue =  this.state.returnOrderFilterList.filter(function(val) {return val.lot_code !== value.RID_LOT_CD})
            const oldSelectedProduct =  this.state.returnOrderProduct.filter(function(val) {return val.RID_LOT_CD !== value.RID_LOT_CD})
                this.setState({ returnOrderFilterList: oldSelectedValue, returnOrderProduct: oldSelectedProduct})
        } 
    }

    // CheckBox the Reason

    handleCheckboxReason = (e, value, index) => {
        if(e.target.checked){
            this.setState({ returnCheckbox : this.state.returnCheckbox.concat([index]) })
        }
        else{
            let returnCheckboxtValue =  this.state.returnCheckbox.filter(function(val) {return val !== index})
            let returnSelectValue =  this.state.returnSelect.filter(function(val) {return val !== index})
            const oldSelectedValue =  this.state.returnOrderFilterList.filter(function(val) {return val.lot_code !== value.RID_LOT_CD})
            const oldSelectedProduct =  this.state.returnOrderProduct.filter(function(val) {return val.RID_LOT_CD !== value.RID_LOT_CD})
            this.setState({ returnCheckbox : returnCheckboxtValue, returnSelect : returnSelectValue, returnOrderFilterList: oldSelectedValue, returnOrderProduct: oldSelectedProduct })
            this['myReasonList'+index].value = '';
        }
    }

    handleReturnOrder = () => {
        if(this.state.returnOrderFilterList.length !== 0 || this.state.returnCheckbox.length !== 0){
            if(JSON.stringify(this.state.returnSelect) === JSON.stringify(this.state.returnCheckbox)){
            this.props.history.push(`/profile/return-cart`)
            this.props.getReturnOrderFilterList(this.state.returnOrderFilterList)
            this.props.getReturnOrderProduct(this.state.returnOrderProduct)
            }
            else if(this.state.returnSelect.length < this.state.returnCheckbox.length){
                toast.error("Please select a Product Reason to proceed with Return.")
            }
            else if(this.state.returnSelect.length > this.state.returnCheckbox.length){
                toast.error("Please select Checkbox")
            }
        }
        else{
            toast.error("Please select a Product to proceed with Return Order.")
        }
    }

    

    render() {

        const { returnOrderList, symbol, loading, returnOrderReasonList } = this.props;

        if (loading) return <div><FullPageLoader /></div>
        return (
            <div>
                {/*SEO Support*/}
                <Helmet>
                <title>{this.props.customer_name} | Return Orders</title>
                </Helmet>
                {/*SEO Support End */}

                {returnOrderList.length > 0 ?
                
                    <section className="cart-section section-b-space">
                        <div className="container">
                            <div className="row">
                                <div className="col-sm-12">
                                <div className="mini-title">
                                        <span>Return Orders</span>
                                    </div>
                                    <div className="mini-title-divider"></div>
                                     {/* Mobile Titlw Section */}
                                     <div className="mobile-title">
                                        <span>Return Orders</span>
                                    </div>
                                    <div className="mobile-divider"></div>
                                    {/* Mobile Titlw Section Ends*/}
                                    <table className="table cart-table table-responsive-xs">
                                        <thead>
                                            <tr className="table-head">
                                                <th scope="col">image</th>
                                                <th scope="col">product name</th>
                                                <th scope="col">price</th>
                                                <th scope="col">quantity</th>
                                                <th scope="col">size</th>
                                                <th scope="col">order no</th>
                                                <th scope="col">order date</th>
                                                <th scope="col">Reason</th>
                                                <th scope="col"></th>
                                            </tr>
                                        </thead>
                                        {returnOrderList.sort((a,b) => new Date(b.RIH_CART_CREATE_DATE) - new Date(a.RIH_CART_CREATE_DATE)).map((item, index) => {
                                            return (
                                                <tbody key={index}>
                                                    <tr>
                                                        <td>
                                                            <Link to={`${process.env.PUBLIC_URL}/PD/${item.RID_LOT_CD}`}>
                                                                <img src={item.SKU_IMAGE} alt={item.SKU_IMAGE} />
                                                            </Link>
                                                        </td>
                                                        <td><Link to={`${process.env.PUBLIC_URL}/PD/${item.RID_LOT_CD}`} className="no-display-pls">{item.SKU_DESC}</Link>
                                                            <MobileView 
                                                            view={'returnOrder'}
                                                            data={item}
                                                            functions={{
                                                                handleSelectReason: this.handleSelectReason,
                                                                handleCheckboxReason: this.handleCheckboxReason
                                                            }}
                                                            reasonList = {returnOrderReasonList}
                                                            />
                                                        </td>
                                                        <td className="no-display-pls"><h6>{symbol}{item.RIH_CART_AMT}</h6></td>
                                                        <td className="no-display-pls"><h6>{item.RID_RETURN_QTY}</h6></td>
                                                        <td className="no-display-pls"><h6>{item.SKU_VARIANT2_VALUE_DESC}</h6></td>
                                                        <td className="no-display-pls"><h6>{item.RIH_PRINCIPAL_ORDER_NO}</h6></td>
                                                        <td className="no-display-pls"><h6>{item.RIH_PRINCIPAL_ORDER_DATE}</h6></td>
                                                        <td className="no-display-pls">
                                                            <select className={"form-control"} ref={reasons => this['myReasonList'+index] = reasons} onChange={(e)=>this.handleSelectReason(e,item, index)} >
                                                            <option value="">Select Reason</option>
                                                            {returnOrderReasonList && returnOrderReasonList.map((reason, i) =>
                                                            <option key={i} value={reason.RSD_REASON_CD}>{reason.RSD_REASON_NAME}</option>
                                                               )}
                                                            </select>
                                                        </td>
                                                        <td className="no-display-pls"><h6><input type="checkbox" value={item.SKU_DESC}  onClick={(e)=>this.handleCheckboxReason(e,item, index)} /></h6></td>
                                                    </tr>
                                                </tbody>)
                                        })}
                                    </table>
                                </div>
                            </div>
                            <div className="row cart-buttons">
                                <div className="col-12">
                                    <button className="btn btn-solid" onClick={() => this.handleReturnOrder()}>Continue</button>
                                </div>
                            </div>
                        </div>
                    </section>
                    :
                    <section className="cart-section section-b-space">
                        <div className="container">
                            <div className="row">
                                <div className="col-sm-12">
                                    <div >
                                        <div className="col-sm-12 empty-cart-cls text-center">
                                            <img src={`${process.env.PUBLIC_URL}/assets/images/icon-empty-cart.png`} className="img-fluid mb-4" alt="" />
                                            <h5>
                                                <strong>You do not have any Orders to view.</strong>
                                            </h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                }
            </div>
        )
    }
}
const mapStateToProps = (state) => ({
    loading: state.returnOrder.loading,
    returnOrderList: state.returnOrder.returnOrderList,
    returnOrderReasonList:state.returnOrder.returnOrderReasonList,
    userDetails: state.user.user_details,
    symbol: state.data.symbol,
    customer_name: state.tenant.tenant_details.STE_ECOM_BRAND_NAME || "",
})

export default connect(
    mapStateToProps,
    { getReturnOrderList, getReturnOrderFilterList, getReturnOrderProduct }
)(withRouter(ReturnOrders))